export function operacaoDrenosInRequest(params = {}) {
  return {
    type: '@operacaodreno/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoDreno(id) {
  return {
    type: '@operacaodreno/FIND_OPERACAOMEDICAOTEMPERATURA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaodreno/FAILED_REQUEST',
  };
}

export function deleteOperacaoDreno(id, params, query = {}) {
  return {
    type: '@operacaodreno/DELETE_OPERACAOMEDICAOTEMPERATURA',
    payload: { id, params, query },
  };
}

export function updateOperacaoDreno(
  operacaodreno,
  params
) {
  return {
    type: '@operacaodreno/UPDATE_OPERACAOMEDICAOTEMPERATURA',
    payload: { operacaodreno, params },
  };
}

export function storeOperacaoDreno(
  operacaodreno,
  params
) {
  return {
    type: '@operacaodreno/STORE_OPERACAOMEDICAOTEMPERATURA',
    payload: { operacaodreno, params },
  };
}

export function successInRequest(
  operacaodrenos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaodreno/SUCCESS_IN_REQUEST',
    payload: {
      operacaodrenos,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaodreno) {
  return {
    type: '@operacaodreno/SUCCESS_REQUEST',
    payload: { operacaodreno },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaodreno/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaodreno/RECORD_FILTERING',
    payload: { params },
  };
}

export function update(data, params) {
  return {
    type: '@operacaodreno/UPDATE',
    payload: { data, params },
  };
}

